import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ForgotPassword.css';
import baseURL from "../../../Url/NodeBaseURL";
import { FaEye, FaEyeSlash } from 'react-icons/fa';


function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState('');
    const [generatedOtp, setGeneratedOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [uid, setUid] = useState('');
    const navigate = useNavigate();
    const generateOTP = () => Math.floor(100000 + Math.random() * 900000).toString();

    const handleSendOtp = async () => {
        setIsSending(true);
        const genOtp = generateOTP();
        setGeneratedOtp(genOtp);

        try {
            await fetch(`${baseURL}/store-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, otp: genOtp })
            });

            await fetch(`${baseURL}/send-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, otp: genOtp })
            });

            const res = await fetch(`${baseURL}/get-userId?email=${email}`);
            const data = await res.json();

            if (data.success) {
                setUid(data.id);
                setStep(2);
                alert('OTP sent to email.');
            } else {
                alert('Email not found.');
            }
        } catch (err) {
            console.error(err);
            alert('Failed to send OTP.');
        } finally {
            setIsSending(false);
        }
    };


    const handleVerifyOtp = () => {
        setIsVerifying(true);
        setTimeout(() => {
            if (otp === generatedOtp) {
                setStep(3);
            } else {
                alert('Invalid OTP');
            }
            setIsVerifying(false);
        }, 800); // small delay for UX
    };

    const handlePasswordReset = async () => {
        if (newPassword !== confirmPassword) {
            alert("Passwords don't match");
            return;
        }

        try {
            await fetch(`${baseURL}/api/users/${uid}/password`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ newPassword })
            });

            alert('Password updated successfully!');
            navigate('/');
        } catch (err) {
            console.error('Failed to update password:', err);
            alert('Something went wrong while resetting password.');
        }
    };

    return (
        <>
            <div className="forgot-wrapper">
                <div className="forgot-box">
                    <h2>Forgot Password</h2>
                    {step === 1 && (
                        <>
                            <div className="forgot-form">
                                <input
                                    type="email"
                                    placeholder="Enter your registered email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <button
                                    onClick={handleSendOtp}
                                    className="forgot-btn"
                                    disabled={isSending}
                                >
                                    {isSending ? 'Sending…' : 'Send OTP'}
                                </button>
                            </div>
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <div className="forgot-form">
                                <input
                                    type="text"
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                />
                                <button
                                    onClick={handleVerifyOtp}
                                    className="forgot-btn"
                                    disabled={isVerifying}
                                >
                                    {isVerifying ? 'Verifying…' : 'Verify OTP'}
                                </button>
                            </div>
                        </>
                    )}

                    {step === 3 && (
                        <>
                            <div className="forgot-form">
                                <div className="password-field">
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        placeholder="New Password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <span
                                        className="eye-icon"
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                    >
                                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                <div className="password-field">
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        placeholder="Confirm Password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <span
                                        className="eye-icon"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                <button onClick={handlePasswordReset} className="forgot-btn">
                                    Reset Password
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
